var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { create } from "apisauce";
import { UserApi, AuthApi, UserGroupApi, CategoryApi, SubCategoryApi, ContentApi, ContentSectionApi, DayProgramApi, DayProgramSectionApi, AppInfoApi, } from "./services";
import { SearchApi } from "./services/SearchApi";
export var ApplicationEnvironment;
(function (ApplicationEnvironment) {
    ApplicationEnvironment["staging"] = "https://eteva-api.stage.geniem.io";
    ApplicationEnvironment["development"] = "http://localhost:1337";
    ApplicationEnvironment["mobile"] = "http://10.0.2.2:1337";
    // mobile = "http://192.168.100.101:1337",
    ApplicationEnvironment["production"] = "https://eteva-api.production.geniem.io";
})(ApplicationEnvironment || (ApplicationEnvironment = {}));
export var TokenValidResponse;
(function (TokenValidResponse) {
    TokenValidResponse[TokenValidResponse["valid"] = 0] = "valid";
    TokenValidResponse[TokenValidResponse["invalid"] = 1] = "invalid";
    TokenValidResponse[TokenValidResponse["offline"] = 2] = "offline";
})(TokenValidResponse || (TokenValidResponse = {}));
export class RestApi {
    constructor() {
        var _a, _b, _c, _d, _e, _f;
        // --------- SELECT ENVIRONMENT ---------
        this.environment = ApplicationEnvironment.production;
        // When we receive a token through login or registering, save it and reinitialize our api instance
        this.authCallback = (token) => __awaiter(this, void 0, void 0, function* () {
            yield this.saveToken(token);
            const initialized = yield this.init(token);
            if (initialized)
                return true;
            return false;
        });
        // TODO: Setup mobile builds to use their own .env, this will only work on web
        let env = "production";
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.includes(".stage.geniem.io")) {
            env = "staging";
        }
        else if ((_d = (_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.hostname) === null || _d === void 0 ? void 0 : _d.includes(".production.geniem.io")) {
            env = "production";
        }
        else if ((_f = (_e = window === null || window === void 0 ? void 0 : window.location) === null || _e === void 0 ? void 0 : _e.href) === null || _f === void 0 ? void 0 : _f.includes("debugger-ui")) {
            env = "mobile";
        }
        else {
            env = "production";
        }
        console.log("ENVIRONMENT: ", env);
        this.environment = ApplicationEnvironment[env];
    }
    get baseUrl() {
        return this.environment;
    }
    get accessToken() {
        return this.token;
    }
    get isLoggedIn() {
        return Boolean(this.accessToken && this.accessToken.length);
    }
    /**
     * Creates an instance of our API
     *
     * @param token Optional, can be passed if for example reinitiating API after login
     * @returns Whether API was initiated with auth header
     */
    init(token) {
        return __awaiter(this, void 0, void 0, function* () {
            this.token = yield this.loadToken();
            // If no token exists nor is provided, create API with only required services and return
            if ((!token || !token.length) && (!this.token || !this.token.length)) {
                this.httpClient = create({
                    baseURL: this.environment,
                });
                // --------- INITIALIZE UNAUTHENTICATED API SERVICES ---------
                this.auth = new AuthApi(this.httpClient);
                this.userGroups = new UserGroupApi(this.httpClient);
                this.categories = new CategoryApi(this.httpClient);
                this.subCategories = new SubCategoryApi(this.httpClient);
                this.contents = new ContentApi(this.httpClient);
                this.contentSections = new ContentSectionApi(this.httpClient);
                this.search = new SearchApi(this.httpClient);
                this.dayPrograms = new DayProgramApi(this.httpClient);
                this.dayProgramSections = new DayProgramSectionApi(this.httpClient);
                this.appInfo = new AppInfoApi(this.httpClient);
                console.log("no token exists nor is provided");
                return false;
            }
            // If we have a token, create api with auth header and services
            this.httpClient = create({
                baseURL: this.environment,
                headers: {
                    authorization: token || this.accessToken,
                },
            });
            this.auth = new AuthApi(this.httpClient);
            const isTokenValid = yield this.httpClient.get("/health/token");
            if (!isTokenValid.ok) {
                this.cleanUserData();
                return false;
            }
            // --------- INITIALIZE AUTHENTICATED API SERVICES ---------
            this.users = new UserApi(this.httpClient);
            this.userGroups = new UserGroupApi(this.httpClient);
            this.categories = new CategoryApi(this.httpClient);
            this.subCategories = new SubCategoryApi(this.httpClient);
            this.contents = new ContentApi(this.httpClient);
            this.contentSections = new ContentSectionApi(this.httpClient);
            this.search = new SearchApi(this.httpClient);
            this.dayPrograms = new DayProgramApi(this.httpClient);
            this.dayProgramSections = new DayProgramSectionApi(this.httpClient);
            this.appInfo = new AppInfoApi(this.httpClient);
            return true;
        });
    }
    version() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get("/health/version");
            if (!res.ok) {
                return null;
            }
            return res.data.version;
        });
    }
    login(email, password, validRoles) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.auth.login(email, password, validRoles, this.authCallback);
        });
    }
    register(registeringUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.auth.register(registeringUser, this.authCallback);
        });
    }
    checkIfTokenIsValid() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO implement rest api check to determine if token is still good
            if (this.isLoggedIn) {
                return TokenValidResponse.valid;
            }
            else
                return TokenValidResponse.invalid;
        });
    }
}
//# sourceMappingURL=RestApi.js.map